import { TFunction } from 'i18next'

export const campaignTypes = (t: TFunction<'translation', undefined>) => [
    { key: 'blast', label: t('campaign_type_blast') },
    { key: 'trigger', label: t('campaign_type_trigger') },
]

export const campaignChannels = (t: TFunction<'translation', undefined>) => [
    { key: 'email', label: t('email') },
    { key: 'text', label: t('text') },
    { key: 'push', label: t('push') },
    { key: 'webhook', label: t('webhook') },
    { key: 'in_app', label: t('in_app') },
]

export const campaignStates = (t: TFunction<'translation', undefined>) => [
    { key: 'aborted', label: t('aborted') },
    { key: 'draft', label: t('draft') },
    { key: 'finished', label: t('finished') },
    { key: 'loading', label: t('loading') },
    { key: 'running', label: t('running') },
    { key: 'scheduled', label: t('scheduled') },
    { key: 'archived', label: t('archived') },
]

export const campaignSendStates = (t: TFunction<'translation', undefined>) => [
    { key: 'pending', label: t('pending') },
    { key: 'sent', label: t('sent') },
    { key: 'throttled', label: t('throttled') },
    { key: 'failed', label: t('failed') },
    { key: 'aborted', label: t('aborted') },
    { key: 'bounced', label: t('bounced') },
]
